import { PERSIST_ON_LOGOUT_PREFIXES } from "../constants/storage";

export const clearStorageForLogout = () => {
  try {
    const preserved = Object.keys(localStorage)
      .filter((key) =>
        PERSIST_ON_LOGOUT_PREFIXES.some((prefix) => key.startsWith(prefix))
      )
      .map((key) => [key, localStorage.getItem(key)]);

    localStorage.clear();

    preserved.forEach(([key, value]) => localStorage.setItem(key, value));
  } catch (error) {
    console.error("clearStorageForLogout failed:", error);
  }
};
